export function cachePromise<T>(factory: () => Promise<T>) {
  let promise: Promise<T> | null = null;

  return () => {
    if (!promise) {
      promise = factory().catch(err => {
        promise = null;
        throw err;
      });
    }
    return promise;
  };
}

export const getVersion: () => Promise<string | null> = cachePromise(
  async () => '',
);

export const DeviceInfo = {
  getVersion,
};
export default DeviceInfo;
